import React from "react"
import QuizApp from "./QuizIndex"

function App() {
  return (
    <div className="App">
      <QuizApp />
    </div>
  )
}

export default App
